import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Group, Badge, ActionIcon, Text, Box } from '@mantine/core';
import { IconArrowRight, IconX } from '@tabler/icons-react';

interface Prediction {
  path: string;
  probability: number;
  label: string;
}

interface NextTaskSuggestionProps {
  suggestions: Prediction[];
  mode: string;
}

export default function NextTaskSuggestion({ suggestions, mode }: NextTaskSuggestionProps) {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !suggestions.length) return null;
  if (mode !== 'suggest' && mode !== 'both') return null;

  return (
    <Box
      mb="sm"
      px="md"
      py={8}
      style={{
        borderRadius: 'var(--mantine-radius-md)',
        backgroundColor: 'var(--mantine-color-gray-0)',
        border: '1px solid var(--mantine-color-gray-2)',
      }}
    >
      <Group justify="space-between" wrap="nowrap">
        <Group gap="xs" wrap="wrap">
          <Text size="xs" c="dimmed" fw={500}>
            Continue to
          </Text>
          {suggestions.map((s) => (
            <Badge
              key={s.path}
              variant="light"
              color="brand"
              size="lg"
              radius="xl"
              style={{ cursor: 'pointer' }}
              rightSection={<IconArrowRight size={12} />}
              onClick={() => navigate(s.path)}
            >
              {s.label} ({Math.round(s.probability * 100)}%)
            </Badge>
          ))}
        </Group>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          radius="xl"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss task suggestions"
        >
          <IconX size={14} />
        </ActionIcon>
      </Group>
    </Box>
  );
}
